import { render, staticRenderFns } from "./BarEchart4.vue?vue&type=template&id=19b8adcb&"
import script from "./BarEchart4.vue?vue&type=script&lang=js&"
export * from "./BarEchart4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports